export const OKTA_STORAGE_KEY = 'Okta';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const ID_TOKEN_KEY = 'idToken';
export const OKTA_TOKEN_STORAGE_CHANGED_EVENT = 'okta-token-storage-changed';
